<div *ngIf="disabled; else showMenu">
  <button [ngClass]="buttonClass" [pTooltip]="tooltip" class="p-button-text" pButton type="button" [disabled]="true">
    <i
      *ngIf="iconLeft"
      [class]="iconLeft"
      [ngClass]="{
        'text-white': textWhite
      }"></i>
    <span *ngIf="label" class="mx-2 overflow-hidden text-ellipsis text-white">
      {{ label }}
    </span>
    <i
      *ngIf="iconRight"
      [class]="iconRight"
      [ngClass]="{
        'text-white': textWhite
      }"></i>
  </button>
</div>
<ng-template #showMenu>
  <p-tieredMenu #menu [model]="tieredMenuItems" [popup]="true" appendTo="body"></p-tieredMenu>
  <button
    (click)="menu.toggle($event)"
    class="p-button-text"
    [ngClass]="buttonClass"
    pButton
    type="button"
    aria-haspopup="menu"
    aria-controls="menu"
    [attr.aria-expanded]="menu.visible">
    <i
      *ngIf="iconLeft"
      [class]="iconLeft"
      [ngClass]="{
        'text-white': textWhite
      }"></i>
    <span *ngIf="label" class="mx-2 overflow-hidden text-ellipsis text-white">
      {{ label }}
    </span>
    <i
      *ngIf="iconRight"
      [class]="iconRight"
      [ngClass]="{
        'text-white': textWhite
      }"></i>
  </button>
</ng-template>
